import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import GallerySection from "../components/GallerySection";

import "../styles/Home.css";

export default function Home() {
  const navigate = useNavigate();
  const [fadeOut, setFadeOut] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);

  useEffect(() => {
    // Start fade-out after 10 seconds
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (fadeOut) {
      // After the fade-out transition (e.g., 1s), remove the overlay from the DOM
      const removeTimer = setTimeout(() => {
        setShowOverlay(false);
      }, 1000); // 1000ms should match the CSS transition duration

      return () => clearTimeout(removeTimer);
    }
  }, [fadeOut]);

  const handleClick = () => {
    navigate("/shop");
  };

  return (
    <div className="home-container" onClick={handleClick}>
      <div className="holiday-banner">
        <video autoPlay loop muted playsInline className="background-video">
          <source src="new_homepage_cut.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        {showOverlay && (
          <div className={`overlay ${fadeOut ? "fade-out" : ""}`}>
            <h1 className="title">Spring 2025</h1>
            <p className="description">
              Where Fashion Meets Function: Swimwear That Keeps Your Essentials
              Dry
            </p>
            <div className="link-group">
              <div className="link">EXPLORE NOW</div>
            </div>
          </div>
        )}
      </div>
      <div className="gallery-title">
        <h3>The Marrakesh Edit</h3>
      </div>
      <GallerySection />
    </div>
  );
}
